// extracted by mini-css-extract-plugin
export default {"activeLine":"Connection_activeLine__NrHDv","active":"Connection_active__tuXny","inactiveLine":"Connection_inactiveLine__HF7Ex"};